import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { Select, Button } from "../partials";
import { groupDealerships, formatGroupLabel } from "~/js/utils";

let dealershipsGrouped =[];

class FinanceSelect extends Component {
    state = {
        href: null,
    };

    constructor(props) {
        super(props);
        dealershipsGrouped = groupDealerships(
            this.props.regions,
            "Select Dealership"
        );

        window.heartland_id = null;

        this.filters = {
            dealers: {
                field: {
                    onChange: ({ dealer }) => {
                        if (typeof dealer == "undefined")
                            return this.setState({ href: null });

                        let id =
                            dealer.data["dealership-details"].heartland_id;
                        if(!id){
                             id = 1;
                        }
                        this.setState({
                            href:
                                "https://digital.heartland.co.nz/#/apply-for-armstrongs-finance/armstrongs-car-loan-calculator?pc=" +
                                id,
                        });
                    },
                    options: dealershipsGrouped,
                    formatGroupLabel: formatGroupLabel,
                },
            },
        };
    }
    render() {
        return (
            <>
                <div class={`display-flex-select`}><p>1</p><Select {...this.filters.dealers.field} modifiers={["form"]} /></div>
                <div className={`display-flex-select`}><p>2</p>
                    <Button
                        title={`Apply for finance`}
                        modifiers={["solid", "black"]}
                        openLink={true}
                        type="button"
                        disabled={this.state.href === null}
                        href={this.state.href}
                        target="_blank"
                        extraClass="ml-5pc"
                    />
                </div>
                <hr />
            </>
        );
    }
}

export default function(el, props) {
    ReactDOM.render(<FinanceSelect {...props} />, el);
}
